import type * as Types from '../../../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetProjectListForNavigationQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetProjectListForNavigationQuery = { projectList: { projects: Array<{ id: number, parentFileId: number | null, name: string, description: string | null, isPrivateWorkspace: boolean, color: string | null, lastModified: string | null, userGroup: { name: string } | null }> } | null };

export type GetAccessibleProjectGroupsQueryVariables = Types.Exact<{
  includeStagedProjects?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetAccessibleProjectGroupsQuery = { userGroup: { accessibleUserGroups: Array<{ id: number, name: string, accessibleProjects: Array<{ capabilities: Map<unknown, unknown> | null, id: number, parentFileId: number | null, name: string, description: string | null, isPrivateWorkspace: boolean, color: string | null, lastModified: string | null, userGroup: { name: string } | null }> }> } | null, userParams: { lastSaveTarget: number | null } | null };

export type GetProjectForPagesQueryVariables = Types.Exact<{
  projectId: Types.Scalars['Long']['input'];
}>;


export type GetProjectForPagesQuery = { project: { id: number, parentFileId: number | null, name: string, description: string | null, isPrivateWorkspace: boolean, color: string | null, lastModified: string | null, userGroup: { name: string } | null } | null };

export type GetProjectStatisticsQueryVariables = Types.Exact<{
  projectId: Types.Scalars['Long']['input'];
}>;


export type GetProjectStatisticsQuery = { project: { projectStatistics: { eventCount: number | null } } | null };

export type GetProjectSettingsQueryVariables = Types.Exact<{
  projectId: Types.Scalars['Long']['input'];
}>;


export type GetProjectSettingsQuery = { project: { isUserAdmin: boolean, isPublic: boolean, capabilities: Map<unknown, unknown> | null, created: string, lastModified: string | null, startDate: string | null, projectedEndDate: string | null, initialEndDate: string | null, actualEndDate: string | null, status: string | null, statusNotes: string | null, endNotes: string | null, goal: string | null, lastUpdate: string | null, id: number, parentFileId: number | null, name: string, description: string | null, isPrivateWorkspace: boolean, color: string | null, projectMembers: Array<{ roleId: number | null, user: { id: number, username: string | null, firstName: string | null, lastName: string | null, email: string | null, display: string | null } | null }> | null, userGroup: { id: number, name: string, description: string | null, members: Array<{ id: number, firstName: string | null, lastName: string | null, username: string | null }> } | null, creator: { id: number, username: string | null, firstName: string | null, lastName: string | null, email: string | null, display: string | null } | null } | null };

export type GetAllFilesInProjectForAttachmentsQueryVariables = Types.Exact<{
  projectId: Types.Scalars['Long']['input'];
}>;


export type GetAllFilesInProjectForAttachmentsQuery = { projectFiles: Array<{ id: number, created: string | null, description: string | null, fileName: string | null, fileType: string | null, lastModified: string | null, typeDisplayName: string | null, creator: { id: number, username: string | null, firstName: string | null, lastName: string | null, email: string | null, display: string | null } | null, organisms: Array<{ id: number, name: string | null, species: { name: string } | null } | null> | null, parents: Array<{ id: number | null, name: string | null, parentType: { name: string } }> | null, contentType: { name: string | null, description: string | null, id: number | null } | null } | null> | null };

export type ProjectBasisFragment = { id: number, parentFileId: number | null, name: string, description: string | null, isPrivateWorkspace: boolean, color: string | null, lastModified: string | null, userGroup: { name: string } | null };

export type ProjectColoredWidgetFragment = { id: number, name: string, color: string | null };

export type UserBasicsFragment = { id: number, username: string | null, firstName: string | null, lastName: string | null, email: string | null, display: string | null };

export const ProjectBasisFragmentDoc = gql`
    fragment ProjectBasis on Project {
  id
  parentFileId
  name
  description
  isPrivateWorkspace
  color
  lastModified
  userGroup {
    name
  }
}
    `;
export const ProjectColoredWidgetFragmentDoc = gql`
    fragment ProjectColoredWidget on Project {
  id
  name
  color
}
    `;
export const UserBasicsFragmentDoc = gql`
    fragment UserBasics on User {
  id
  username
  firstName
  lastName
  email
  display
}
    `;
export const GetProjectListForNavigationDocument = gql`
    query getProjectListForNavigation {
  projectList(sortOrder: "name") {
    projects {
      ...ProjectBasis
    }
  }
}
    ${ProjectBasisFragmentDoc}`;

/**
 * __useGetProjectListForNavigationQuery__
 *
 * To run a query within a React component, call `useGetProjectListForNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectListForNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectListForNavigationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectListForNavigationQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectListForNavigationQuery, GetProjectListForNavigationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectListForNavigationQuery, GetProjectListForNavigationQueryVariables>(GetProjectListForNavigationDocument, options);
      }
export function useGetProjectListForNavigationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectListForNavigationQuery, GetProjectListForNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectListForNavigationQuery, GetProjectListForNavigationQueryVariables>(GetProjectListForNavigationDocument, options);
        }
export function useGetProjectListForNavigationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectListForNavigationQuery, GetProjectListForNavigationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectListForNavigationQuery, GetProjectListForNavigationQueryVariables>(GetProjectListForNavigationDocument, options);
        }
export type GetProjectListForNavigationQueryHookResult = ReturnType<typeof useGetProjectListForNavigationQuery>;
export type GetProjectListForNavigationLazyQueryHookResult = ReturnType<typeof useGetProjectListForNavigationLazyQuery>;
export type GetProjectListForNavigationSuspenseQueryHookResult = ReturnType<typeof useGetProjectListForNavigationSuspenseQuery>;
export type GetProjectListForNavigationQueryResult = Apollo.QueryResult<GetProjectListForNavigationQuery, GetProjectListForNavigationQueryVariables>;
export const GetAccessibleProjectGroupsDocument = gql`
    query getAccessibleProjectGroups($includeStagedProjects: Boolean = false) {
  userGroup {
    accessibleUserGroups {
      id
      name
      accessibleProjects(includeStagedProjects: $includeStagedProjects) {
        ...ProjectBasis
        capabilities
      }
    }
  }
  userParams {
    lastSaveTarget
  }
}
    ${ProjectBasisFragmentDoc}`;

/**
 * __useGetAccessibleProjectGroupsQuery__
 *
 * To run a query within a React component, call `useGetAccessibleProjectGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccessibleProjectGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccessibleProjectGroupsQuery({
 *   variables: {
 *      includeStagedProjects: // value for 'includeStagedProjects'
 *   },
 * });
 */
export function useGetAccessibleProjectGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetAccessibleProjectGroupsQuery, GetAccessibleProjectGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccessibleProjectGroupsQuery, GetAccessibleProjectGroupsQueryVariables>(GetAccessibleProjectGroupsDocument, options);
      }
export function useGetAccessibleProjectGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccessibleProjectGroupsQuery, GetAccessibleProjectGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccessibleProjectGroupsQuery, GetAccessibleProjectGroupsQueryVariables>(GetAccessibleProjectGroupsDocument, options);
        }
export function useGetAccessibleProjectGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccessibleProjectGroupsQuery, GetAccessibleProjectGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccessibleProjectGroupsQuery, GetAccessibleProjectGroupsQueryVariables>(GetAccessibleProjectGroupsDocument, options);
        }
export type GetAccessibleProjectGroupsQueryHookResult = ReturnType<typeof useGetAccessibleProjectGroupsQuery>;
export type GetAccessibleProjectGroupsLazyQueryHookResult = ReturnType<typeof useGetAccessibleProjectGroupsLazyQuery>;
export type GetAccessibleProjectGroupsSuspenseQueryHookResult = ReturnType<typeof useGetAccessibleProjectGroupsSuspenseQuery>;
export type GetAccessibleProjectGroupsQueryResult = Apollo.QueryResult<GetAccessibleProjectGroupsQuery, GetAccessibleProjectGroupsQueryVariables>;
export const GetProjectForPagesDocument = gql`
    query getProjectForPages($projectId: Long!) {
  project(projectId: $projectId) {
    ...ProjectBasis
  }
}
    ${ProjectBasisFragmentDoc}`;

/**
 * __useGetProjectForPagesQuery__
 *
 * To run a query within a React component, call `useGetProjectForPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectForPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectForPagesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectForPagesQuery(baseOptions: Apollo.QueryHookOptions<GetProjectForPagesQuery, GetProjectForPagesQueryVariables> & ({ variables: GetProjectForPagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectForPagesQuery, GetProjectForPagesQueryVariables>(GetProjectForPagesDocument, options);
      }
export function useGetProjectForPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectForPagesQuery, GetProjectForPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectForPagesQuery, GetProjectForPagesQueryVariables>(GetProjectForPagesDocument, options);
        }
export function useGetProjectForPagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectForPagesQuery, GetProjectForPagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectForPagesQuery, GetProjectForPagesQueryVariables>(GetProjectForPagesDocument, options);
        }
export type GetProjectForPagesQueryHookResult = ReturnType<typeof useGetProjectForPagesQuery>;
export type GetProjectForPagesLazyQueryHookResult = ReturnType<typeof useGetProjectForPagesLazyQuery>;
export type GetProjectForPagesSuspenseQueryHookResult = ReturnType<typeof useGetProjectForPagesSuspenseQuery>;
export type GetProjectForPagesQueryResult = Apollo.QueryResult<GetProjectForPagesQuery, GetProjectForPagesQueryVariables>;
export const GetProjectStatisticsDocument = gql`
    query getProjectStatistics($projectId: Long!) {
  project(projectId: $projectId) {
    projectStatistics {
      eventCount
    }
  }
}
    `;

/**
 * __useGetProjectStatisticsQuery__
 *
 * To run a query within a React component, call `useGetProjectStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectStatisticsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectStatisticsQuery(baseOptions: Apollo.QueryHookOptions<GetProjectStatisticsQuery, GetProjectStatisticsQueryVariables> & ({ variables: GetProjectStatisticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectStatisticsQuery, GetProjectStatisticsQueryVariables>(GetProjectStatisticsDocument, options);
      }
export function useGetProjectStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectStatisticsQuery, GetProjectStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectStatisticsQuery, GetProjectStatisticsQueryVariables>(GetProjectStatisticsDocument, options);
        }
export function useGetProjectStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectStatisticsQuery, GetProjectStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectStatisticsQuery, GetProjectStatisticsQueryVariables>(GetProjectStatisticsDocument, options);
        }
export type GetProjectStatisticsQueryHookResult = ReturnType<typeof useGetProjectStatisticsQuery>;
export type GetProjectStatisticsLazyQueryHookResult = ReturnType<typeof useGetProjectStatisticsLazyQuery>;
export type GetProjectStatisticsSuspenseQueryHookResult = ReturnType<typeof useGetProjectStatisticsSuspenseQuery>;
export type GetProjectStatisticsQueryResult = Apollo.QueryResult<GetProjectStatisticsQuery, GetProjectStatisticsQueryVariables>;
export const GetProjectSettingsDocument = gql`
    query getProjectSettings($projectId: Long!) {
  project(projectId: $projectId) {
    ...ProjectBasis
    isUserAdmin
    isPublic
    capabilities
    created
    lastModified
    startDate
    projectedEndDate
    initialEndDate
    actualEndDate
    status
    statusNotes
    endNotes
    status
    statusNotes
    endNotes
    goal
    startDate
    lastUpdate
    initialEndDate
    actualEndDate
    projectedEndDate
    projectMembers {
      roleId
      user {
        ...UserBasics
      }
    }
    userGroup {
      id
      name
      description
      members {
        id
        firstName
        lastName
        username
      }
    }
    creator {
      ...UserBasics
    }
  }
}
    ${ProjectBasisFragmentDoc}
${UserBasicsFragmentDoc}`;

/**
 * __useGetProjectSettingsQuery__
 *
 * To run a query within a React component, call `useGetProjectSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectSettingsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetProjectSettingsQuery, GetProjectSettingsQueryVariables> & ({ variables: GetProjectSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>(GetProjectSettingsDocument, options);
      }
export function useGetProjectSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>(GetProjectSettingsDocument, options);
        }
export function useGetProjectSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>(GetProjectSettingsDocument, options);
        }
export type GetProjectSettingsQueryHookResult = ReturnType<typeof useGetProjectSettingsQuery>;
export type GetProjectSettingsLazyQueryHookResult = ReturnType<typeof useGetProjectSettingsLazyQuery>;
export type GetProjectSettingsSuspenseQueryHookResult = ReturnType<typeof useGetProjectSettingsSuspenseQuery>;
export type GetProjectSettingsQueryResult = Apollo.QueryResult<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>;
export const GetAllFilesInProjectForAttachmentsDocument = gql`
    query getAllFilesInProjectForAttachments($projectId: Long!) {
  projectFiles(projectId: $projectId) {
    id
    created
    creator {
      ...UserBasics
    }
    organisms {
      id
      name
      species {
        name
      }
    }
    parents {
      id
      name
      parentType {
        name
      }
    }
    description
    fileName
    fileType
    lastModified
    typeDisplayName
    contentType {
      name
      description
      id
    }
  }
}
    ${UserBasicsFragmentDoc}`;

/**
 * __useGetAllFilesInProjectForAttachmentsQuery__
 *
 * To run a query within a React component, call `useGetAllFilesInProjectForAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllFilesInProjectForAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllFilesInProjectForAttachmentsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetAllFilesInProjectForAttachmentsQuery(baseOptions: Apollo.QueryHookOptions<GetAllFilesInProjectForAttachmentsQuery, GetAllFilesInProjectForAttachmentsQueryVariables> & ({ variables: GetAllFilesInProjectForAttachmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllFilesInProjectForAttachmentsQuery, GetAllFilesInProjectForAttachmentsQueryVariables>(GetAllFilesInProjectForAttachmentsDocument, options);
      }
export function useGetAllFilesInProjectForAttachmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllFilesInProjectForAttachmentsQuery, GetAllFilesInProjectForAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllFilesInProjectForAttachmentsQuery, GetAllFilesInProjectForAttachmentsQueryVariables>(GetAllFilesInProjectForAttachmentsDocument, options);
        }
export function useGetAllFilesInProjectForAttachmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllFilesInProjectForAttachmentsQuery, GetAllFilesInProjectForAttachmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllFilesInProjectForAttachmentsQuery, GetAllFilesInProjectForAttachmentsQueryVariables>(GetAllFilesInProjectForAttachmentsDocument, options);
        }
export type GetAllFilesInProjectForAttachmentsQueryHookResult = ReturnType<typeof useGetAllFilesInProjectForAttachmentsQuery>;
export type GetAllFilesInProjectForAttachmentsLazyQueryHookResult = ReturnType<typeof useGetAllFilesInProjectForAttachmentsLazyQuery>;
export type GetAllFilesInProjectForAttachmentsSuspenseQueryHookResult = ReturnType<typeof useGetAllFilesInProjectForAttachmentsSuspenseQuery>;
export type GetAllFilesInProjectForAttachmentsQueryResult = Apollo.QueryResult<GetAllFilesInProjectForAttachmentsQuery, GetAllFilesInProjectForAttachmentsQueryVariables>;